module.exports = __webpack_public_path__ + "img/pay_order.d1379fdb.png";